<button style="height: auto;  " class="btn-notification" mat-icon-button
        [matMenuTriggerFor]="menu1"
        aria-label="Example icon-button with a menu"
        (click)="setSeen()"
>
    <i class="fa fa-bell-o"></i>
    <div *ngIf="this.count_unread > 0" class="mark">

        <div class="number">
            {{ this.count_unread}}
        </div>
    </div>
</button>

<mat-menu #menu1="matMenu" class="messages-notification-panel" style="width: 400px;">

    <app-notification-item *ngFor="let noti of notifications|slice:0:4;" [notification]="noti">

    </app-notification-item>
    <b class="btn viewall" [routerLink]="'/admin/all-notifications'">View all Notifications</b>

</mat-menu>

<!--<ng-template #customNotification let-notificationData="notification">-->
<!--    <div class="">-->

<!--        <h4 style="color:#ec7b18;">Global Notification</h4>-->
<!--        <div>Test message</div>-->

<!--    </div>-->
<!--</ng-template>-->
